import clsx from 'clsx';
import {
  useAppointmentSchedulerStore,
  OPSLAG_REDEN_OPTIONS,
} from '../../stores/appointment-scheduler-store';

export function OpslagkostenWaiver() {
  const primaryType = useAppointmentSchedulerStore((s) => s.primaryType);
  const order = useAppointmentSchedulerStore((s) => s.order);
  const geenOpslagkosten = useAppointmentSchedulerStore((s) => s.geenOpslagkosten);
  const choice = useAppointmentSchedulerStore((s) => s.redenGeenOpslagkostenChoice);
  const other = useAppointmentSchedulerStore((s) => s.redenGeenOpslagkostenOther);
  const error = useAppointmentSchedulerStore((s) => s.opslagWaiverError);
  const setGeen = useAppointmentSchedulerStore((s) => s.setGeenOpslagkosten);
  const setChoice = useAppointmentSchedulerStore((s) => s.setRedenGeenOpslagkostenChoice);
  const setOther = useAppointmentSchedulerStore((s) => s.setRedenGeenOpslagkostenOther);

  if (primaryType !== 'delivery') return null;

  // Vlag staat al op de WO (Opties op de order): niets te kiezen, alleen melden.
  // Uitzetten gebeurt op de order zelf; het plan-endpoint kent alleen "aanzetten".
  if (order?.geenOpslagkosten) {
    return (
      <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-xs text-emerald-900">
        <span className="font-medium">Geen opslagkosten</span> staat aan op deze werkorder
        {order.redenGeenOpslagkosten ? ` (reden: ${order.redenGeenOpslagkosten})` : ''}.
        Er wordt geen opslag berekend; uitzetten kan via de opties op de order.
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'rounded-lg border p-3 space-y-2',
        geenOpslagkosten ? 'border-amber-300 bg-amber-50' : 'border-slate-200 bg-white'
      )}
    >
      <label className="flex items-start gap-2 text-xs cursor-pointer select-none">
        <input
          type="checkbox"
          checked={geenOpslagkosten}
          onChange={(e) => setGeen(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-slate-300 text-amber-600 focus:ring-amber-500"
        />
        <span className="text-slate-800">
          Opslagkosten niet doorberekenen
          <span className="block text-slate-500">
            Werkorder krijgt Geen Opslagkosten = aan. Bestaande opslag-items worden automatisch verwijderd.
          </span>
        </span>
      </label>

      {geenOpslagkosten && (
        <div className="space-y-2 pl-6">
          <div>
            <label className="text-[11px] font-medium text-amber-900 block mb-1">
              Reden <span className="text-amber-700">(verplicht)</span>
            </label>
            <select
              value={choice}
              onChange={(e) => setChoice(e.target.value as typeof choice)}
              className="w-full px-2 py-1.5 text-xs border border-amber-300 rounded bg-white text-amber-900 focus:outline-none focus:ring-2 focus:ring-amber-500"
            >
              <option value="">— Kies een reden —</option>
              {OPSLAG_REDEN_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>

          {choice === 'Anders' && (
            <input
              type="text"
              value={other}
              onChange={(e) => setOther(e.target.value)}
              placeholder="Geef een reden op..."
              maxLength={100}
              className="w-full px-2 py-1.5 text-xs border border-amber-300 rounded bg-white text-amber-900 placeholder-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-500"
            />
          )}

          {error && (
            <p className="text-[11px] text-red-700">{error}</p>
          )}
        </div>
      )}
    </div>
  );
}
